import api from "../interceptor/interceptor";

const TripService = {
    async getTrips(startDate, endDate, pNumber = 1, pSize = 10, filters = {}) {
        try {
            const response = await api.get(
                `/api/trip?startDate=${startDate}&endDate=${endDate}&pSize=${pSize}&pNumber=${pNumber}
                &distanceDriven=${filters?.distance}&vehicles=${filters?.vehicles?.join(',')
                }&vehicleGroups=${filters?.groups?.join(',')}`
            )
            return response?.data?.trips;
        } catch (e) {
            return {
                message: e?.response?.data?.errors
            }
        }
    },
    async getTripCounts(startDate, endDate) {
        try {
            const response = await api.get(
                `/trips/info?startDate=${startDate}&endDate=${endDate}`
            )
            return response?.data;

        } catch (e) {
            return {
                message: e?.response?.data?.errors
            }
        }
    },
    async getVehicles() {
        return await api.get(`/vehicles`);
    },
    async getTripAlerts(startDate, endDate) {
        try {
            const userAlerts = (JSON.parse(localStorage.getItem("user-details")))?.skuDetails?.alerts || [];
            const alerts = userAlerts.map((alert) => alert?.alertString);

            const response =  await api.post(`/analytics/api/v1/fleet/safety_performance_treemap`,
                {
                    "fromdate": startDate,
                    "todate": endDate,
                    "date_type": "month",
                    "alertfilter": alerts,
                    "group": "-1",
                    "vehicle": []
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        "Apitype": 'safetyanalysis'
                    }
                }
            )
            return response?.data?.data;
        } catch (e) {
            return {
                message: e?.response?.data?.errors
            }
        }
    }
}


export default TripService;
